(() => {
  if (window.__omSearchDiscoveryLoaded) return;
  window.__omSearchDiscoveryLoaded = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-om-search-form]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    const term = input?.value?.trim();
    if (!term) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'om_search_submit',
      search_term: term,
      search_context: form.dataset.searchContext || 'site'
    });
  });

  document.addEventListener('click', (event) => {
    const shortcut = event.target.closest?.('[data-om-search-shortcut]');
    if (!shortcut) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'om_search_shortcut_click',
      search_shortcut: shortcut.dataset.omSearchShortcut || shortcut.textContent.trim()
    });
  });
})();
